import React from 'react'
import { CustomText } from 'src/components'
import { getTransformedDate } from 'src/core/helpers'
import { ProjectDiscountPayload } from 'src/core/models'

const ProjectDiscountDatesColumn: React.FC<{ discount: ProjectDiscountPayload }> = ({ discount }) => {
  const isFalsy = !discount.date_start && !discount.date_end

  if (isFalsy) return <div className='has-text-centered'>-</div>

  return <>
    <CustomText label={discount.date_start && getTransformedDate(discount.date_start)} /> <br/>
    <CustomText label={discount.date_end && getTransformedDate(discount.date_end)} />
  </>
}

export default ProjectDiscountDatesColumn
